module.exports = __webpack_public_path__ + "static/media/megan-fox-win.2c1ea800.jpg";